import {
  BookmarkIcon,
  FacebookIcon,
  type IconComponent,
  InstagramIcon,
  LinkedInIcon,
  MailIcon,
  MetaIcon,
  ProportionsIcon,
  Share2Icon,
  SnapchatIcon,
  StoreIcon,
  TiktokIcon,
  TwitterIcon,
  YouTubeIcon,
} from '@air/design-icons';

export const WORKSPACE_AGENT_GUIDED_VARIANT_SIZE_GROUP_ICONS: Record<string, IconComponent> = {
  lifecycle: MailIcon,
  linkedin: LinkedInIcon,
  meta: MetaIcon,
  saved: BookmarkIcon,
  shape: ProportionsIcon,
  snapchat: SnapchatIcon,
  social: Share2Icon,
  web_stores: StoreIcon,
  x: TwitterIcon,
  youtube: YouTubeIcon,
};

export const WORKSPACE_AGENT_GUIDED_VARIANT_SIZE_PLATFORM_ICONS: Record<string, IconComponent | undefined> = {
  ...WORKSPACE_AGENT_GUIDED_VARIANT_SIZE_GROUP_ICONS,
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  tiktok: TiktokIcon,
};
